import * as consts from '../../common/consts';
import * as aspSettings from '../aspSettings';
import { ObjectsMenuService } from '../../menu-bars/objects-menu.service';
import { AppInjector } from '../../common/inject';
import { SpecialTool, IMapEventsHandler } from './SpecialTool';
import { IMapMngr } from '../interfaces';
import { MapTool } from './MapTool';
import { UserActionService } from '@core_n/user-action/user-action.service';
import * as projMsgs from '../../../../app/msg/projMsgs';
import * as units from '@core_n/common/units';
import * as enums from '@core_n/common/enums';
import { settings } from 'cluster';
import { userSettings } from '@core_n/common/settings';

export class MapSelectionTool extends MapTool implements IMapEventsHandler {

  private static mapEvents = [
    NeWMI.Map.Enums.EMapEvents.MouseDown,
    NeWMI.Map.Enums.EMapEvents.MouseUp,
    NeWMI.Map.Enums.EMapEvents.MouseDblClick,
  ];

  private _specialTool: SpecialTool;

  constructor(mapMngr: IMapMngr) {
    super(mapMngr, MapSelectionTool.mapEvents);
    this._specialTool = new SpecialTool(MapSelectionTool.mapEvents, this);
  }

  public get specialTool(): SpecialTool {
    return this._specialTool;
  }

  onMapEvent(event): boolean {
    localStorage.setItem(consts.LOCAL_STORAGE_HEIGHT_KEY, '');
    return this.handleMapEvent(event);
  }

  handleMouseDown(event): boolean {
    if (event.button == 0) {
      AppInjector.get(ObjectsMenuService).hideAllMenus(); // closes menu on right click
      let isShowDTM = JSON.parse(localStorage.getItem(consts.LOCAL_STORAGE_SHOW_DTM_KEY));
      if (isShowDTM == true) {
        this.getHeightByLocation(event.mapPoint);
      }
      // left mouse button
      let objects = this.sortObjects(this.mapMngr.objectsAtLocation(event.mapPoint, true));
      if (objects) {
        if (this.mapClickHandler != null) {
          if (objects.length > 0)
            this.mapClickHandler.onObjectsClicked(objects);
        }
        else {
          if (super.handleMouseDown(event))
            return true;
        }
      }
    }

    if (event.button == 2){
      let objects = this.filterOut(this.sortObjects(this.mapMngr.objectsAtLocation(event.mapPoint)));
      //if (objects && objects.length > 0) {
      if (!this.mapMngr.isMapPanning() && userSettings.userPerm == enums.Permission.ADMIN) {
        // Open right click on "hit" objects.
        AppInjector.get(ObjectsMenuService).showContextMenu(objects, event, this.mapMngr);
        // AppInjector.get(ObjectsMenuService).(objects, event, this.mapMngr);
        return true;
      }
      AppInjector.get(ObjectsMenuService).hideAllMenus();
    }
    return this.mapClickHandler != null;
  }

  handleMouseUp(event): boolean {
    // if (this.mapClickHandler != null)
    //   return true;

    // if (event.button == 2) {
    //   // right mouse button

    //   // AppInjector.get(ObjectsMenuService).hideAllMenus(event);

    //   let objects = this.filterOut(this.sortObjects(this.mapMngr.objectsAtLocation(event.mapPoint)));
    //   //if (objects && objects.length > 0) {
    //   if (!this.mapMngr.isMapPanning() && userSettings.userPerm == enums.Permission.ADMIN) {
    //     // Open right click on "hit" objects.
    //     AppInjector.get(ObjectsMenuService).showContextMenu(objects, event, this.mapMngr);
    //     // AppInjector.get(ObjectsMenuService).(objects, event, this.mapMngr);
    //     return true;
    //   }
    // }
    //}

    aspSettings.setMapCoordinate(event.mapPoint);
    return false;
  }

  handleDblClick(event): boolean {
    if (this.mapClickHandler != null)
      return true;

    let objects = this.sortObjects(this.mapMngr.objectsAtLocation(event.mapPoint, true));
    if (objects && objects.length == 1) {
      let obj = objects[0];
      obj.objectsPool.handleUserAction(consts.USER_ACTION_ARO, obj, this.mapMngr);
      return true;
    }
    return false;
  }


  getHeightByLocation(mapPoint) {
    let mapHeightMsg = new projMsgs.GetHeight();
    mapHeightMsg.LocationLat = mapPoint.y * units.DEG_TO_RAD;
    mapHeightMsg.LocationLong = mapPoint.x * units.DEG_TO_RAD;
    AppInjector.get(UserActionService).sendUserAction(mapHeightMsg);
  }

  filterOut(objList: any): any {
    if (!objList)
      return null;

    let nObjList = [];
    objList.forEach(element => {
      if (element.ExIpID) {
        if (element.ExIpID != 1)
          nObjList.push(element);
      }
      else
        nObjList.push(element);
    });
    if (nObjList.length == 0) {
      return null;
    }
    return nObjList;
  }
}
